module.exports = __webpack_public_path__ + "static/img/navbar_1.904a8be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/navbar_1.png
// module id = elZH
// module chunks = 25